import { Button } from '@mui/material';
import Logout from "@mui/icons-material/Logout";
import React from 'react';

interface Props {
    logout: () => void;
}

export const TopNavigation: React.FC<Props> = (props: Props) => {
    return (
        <div id="powered-div" className="tw-text-white tw-bg-midnight-blue tw-text-sm tw-font-light tw-w-screen tw-flow-root"
            style={{height: "60px"}}>
                <div className="tw-float-left tw-my-2 tw-ml-4 tw-flex">
                    <img className={"tw-h-6"} src="./assets/mb-logo-white.svg" alt="Matrix Booking"/>
                    <span className="tw-ml-2 tw-pl-2 tw-border-l tw-border-l-white tw-border-solid"
                        style={{marginTop:4, marginBottom:5}}>Insight</span>
                </div>
                <div className="tw-float-right tw-my-2 tw-mr-4">
                    <Button onClick={props.logout} variant="text"
                        startIcon={<Logout sx={{ color: "#09D88D"}}/>}
                        className="tw-font-light tw-normal-case tw-text-white tw-min-w-0"
                        style={{fontSize: "16px"}}>
                        <span className="tw-hidden sm:tw-block">Log out</span>
                    </Button>
                </div>  
        </div>
    );
}